import { observable, observe, action, Lambda, IObjectDidChange, computed } from "mobx";
import { DataParser } from "../../../DataParser";
import * as Collections from "../../../Interfaces";
import { TooltipApi } from "sb-resp-ui";

/*
    The class has 'istanbul ignore' flag , because of testing typescript interface with Jest.
    It`s known issue : (https://github.com/kulshekhar/ts-jest/issues/378)
    The class is fully tested, but propery "sportsDataChangeFeed" implement interface "ChangeFeedUpdate" which is not
    testable with Jest - there is no types like in typescript
 */

/* istanbul ignore next */
export class PersonalizedHighlightsData {
    public DataParser: DataParser;
    getUniqueOddsClass: Function;
    tooltipApi: TooltipApi;
    @observable events: Collections.EventsObject;
    @observable sports: Collections.SportsObject;
    @observable markets: Collections.MarketsObject;
    @observable selections: Collections.SelectionsObject;
    @observable extDataObjects: Collections.ExtDataObject;

    @observable selectedSportId: string;

    dispose: Lambda;

    constructor(provider: DataParser, getUniqueOddsClass: Function) {
        this.DataParser = provider;

        this.getUniqueOddsClass = getUniqueOddsClass;
        this.tooltipApi = new TooltipApi();

        this.sports = this.DataParser.sports;
        this.events = this.DataParser.events;
        this.markets = this.DataParser.markets;
        this.selections = this.DataParser.selections;
        this.extDataObjects = this.DataParser.extDataObjects;

        this.selectedSportId = "";

        this.updateCollections = this.updateCollections.bind(this);

        this.dispose = () => { };
    }

    activate() {
        this.dispose = observe(this.DataParser, (change: IObjectDidChange) => {
            let changedObject = change.object as DataParser;
            this.updateCollections(changedObject);
        });
        this.DataParser.activate();
    }

    deactivate() {
        this.dispose();
        this.DataParser.deactivate();
    }

    addToSlipTranspiler(selectionId: string) {
        this.DataParser.addToSlipTranspiler(selectionId);
    }

    openGameTranspiler(eventId: string, ev: React.MouseEvent<HTMLAnchorElement>) {
        this.DataParser.openGameTranspiler(ev, eventId);
    }

    openStatTranspiler(eventId: string, ev: Event)
    {
        ev && ev.preventDefault();
        ev && ev.stopPropagation();
        this.DataParser.openStatTranspiler(ev, eventId);
    }

    @action.bound updateCollections(changedObject)
    {
        this.sports = changedObject.sports;
        this.events = changedObject.events;
        this.markets = changedObject.markets;
        this.selections = changedObject.selections;
        this.extDataObjects = changedObject.extDataObjects;
    }

    @computed get eventIdsSortedByPersonalizedSortId() {
        let sortedEventIds = this.sports[this.selectedSportId].eventIds.slice();

        if (this.selectedSportId !== "0") {
            return sortedEventIds.sort(
                (eventId1, eventId2) => {
                    if (this.events[eventId1] === undefined || this.events[eventId2] === undefined) { return -1; }
                    let sortId1 = this.events[eventId1].sortId;
                    let sortId2 = this.events[eventId2].sortId;

                    return parseInt(sortId1) - parseInt(sortId2);
                }
            )
        }

        return sortedEventIds.sort(
            (eventId1, eventId2) => {

                if (this.events[eventId1] === undefined || this.events[eventId2] === undefined) { return -1; }

                let personalizedSortId1 = this.events[eventId1].personalizedSortId;
                let personalizedSortId2 = this.events[eventId2].personalizedSortId;

                return parseInt(personalizedSortId1) - parseInt(personalizedSortId2);
            }
        )
    }

    @computed get sportsSortedById() {
        let sortedSports: any[] = [];
        for (let el in this.sports) {
            if (this.sports.hasOwnProperty(el)) {
                let a = this.sports[el];
                sortedSports[el] = a;
            }
        }
        return sortedSports.sort(function (a, b) { return parseInt(a.sortId) - parseInt(b.sortId) })
    }

    @action.bound setSelectedSportId(sportId: string) {
        this.selectedSportId = sportId;
    }

    @computed get isDataLoaded(): boolean {
        return !(Object.keys(this.sports).length === 0 || Object.keys(this.events).length === 0);
    }

    getSelectionIds(eventId: string): string[] {
        const selectionIds = this.markets[this.events[eventId].marketIds[0]].selectionIds;

        return this.events[eventId].isTeamSwapEnabled ?
            selectionIds.slice().reverse()
            : selectionIds;
    }

    isSelectionInBetslip(selectionId: string): boolean {
        if (!this.selections[selectionId] ||
            !this.markets[this.selections[selectionId].marketId] ||
            !this.events[this.markets[this.selections[selectionId].marketId].eventId]
        ) { return false; }
        let selection = this.selections[selectionId];
        let market = this.markets[selection.marketId];
        let event = this.events[market.eventId];

        return this.DataParser.betSlipUtil.isOddInSlip(
            parseInt(event.id),
            parseInt(this.DataParser.getMarketId(market.id)),
            parseInt(selection.sbTechId),
            parseInt(selection.lineGroupId),
            selection.getSide(),
            parseInt(selection.type),
            false,
            false
        );
    }

}